var jquery = require("/js/lib/jquery");

window.$ = window.jQuery = jquery;

import wsCall, { wsCallAsync } from './wsCall';
import appData from './appData';
import { getParameterByName } from './util';
import 'babel-polyfill';

function App() {
  var self = this;
}

App.prototype.init = async function() {
  var self = this;

  appData.init({
    watch: {
    },
    computed: {
    },
    methods: {
    },
    mounted: function() {
    }
  });

  try {
    let resetPasswordId = getParameterByName('resetPasswordId');
    let emailConfirmId = getParameterByName('emailConfirmId');

    let data = {
        email: getParameterByName('email')
      };

    if (emailConfirmId) {
      data.emailConfirmId = emailConfirmId;
    }
    if (resetPasswordId) {
      data.resetPasswordId = resetPasswordId;
    }

    let result = await wsCallAsync({
      url: "/account/login",
      data: data
    });
    self.initForm(result);
  }
  catch (result) {
    window.location = '/';
  }

};

App.prototype.initForm = async function(loginResult) {

  appData.vm.setupEmail = loginResult.data.data.userInfo.email;

  if (!loginResult.data.data.primaryPhoneId) {
    appData.vm.setupPhoneShow = true;
  }
  if (!loginResult.data.data.isPasswordSet || getParameterByName('resetPasswordId')) {
    appData.vm.setupPasswordShow = true;
  }
  if (getParameterByName('emailConfirmId')) {
    if (loginResult.data.data.isEmailConfirmed) {
      appData.vm.setupEmailConfirmShow = true;
    }
  }

  $('#setupButton').on('click', function() {
    $('#setupSubmit').click();
  });
  $('#setupForm').on('submit', async function(e) {
    e.preventDefault();

    $('#setupButton').addClass('is-loading');
    appData.vm.pageloaderText = 'Loading';
    appData.vm.pageloaderVisible = true;

    try {
      let data = {};

      if (appData.vm.setupPhoneShow) {
        data.phone = appData.vm.setupPhone;
      }
      if (appData.vm.setupPasswordShow) {
        data.password = appData.vm.setupPassword;
      }

      let result = await wsCallAsync({
        url: "/account/setup",
        data: data
      });
      appData.vm.saved.primaryPhoneVerified = result.data.data.primaryPhoneVerified;
      appData.vm.saved.primaryPhoneId = result.data.data.primaryPhoneId;
      appData.vm.saved.phoneLimit = result.data.data.phoneLimit;
      appData.vm.save();
      window.location = '/app/reminderList';
    }
    catch (result) {
    }

  });

};

var app = new App();

app.init();

export default app;

